import React from 'react';
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Loader from "./components/loader/Loader";
import AuthorizationProvider from "./features/authprovider/AuthorizationProvider";
import ApplicationDataProvider from "./features/appdataprovider/ApplicationDataProvider";


const Index = React.lazy(() => import("./features"));

function App() {

    return (
        <AuthorizationProvider>
            <ApplicationDataProvider>
                <React.Suspense fallback={<Loader/>}>
                    <Index/>
                </React.Suspense>
            </ApplicationDataProvider>
        </AuthorizationProvider>
    );
}

export default withAuthenticationRequired(App, {
    onRedirecting: () => <Loader/>
});
